export default __webpack_public_path__ + "static/media/error.e5c28c40.svg";